export default function DesignTab({ formData, onChange }) {
    const colorThemes = [
        { 
            id: 'amber', 
            name: 'Amber', 
            colors: {
                primary: 'amber-800',
                secondary: 'amber-600',
                light: 'amber-50'
            }
        },
        { 
            id: 'blue', 
            name: 'Blå', 
            colors: {
                primary: 'blue-800',
                secondary: 'blue-600',
                light: 'blue-50'
            }
        },
        { 
            id: 'red', 
            name: 'Rød', 
            colors: {
                primary: 'red-800',
                secondary: 'red-600',
                light: 'red-50'
            }
        },
        { 
            id: 'green', 
            name: 'Grøn', 
            colors: {
                primary: 'green-800',
                secondary: 'green-600',
                light: 'green-50'
            }
        },
        { 
            id: 'purple', 
            name: 'Lilla', 
            colors: {
                primary: 'purple-800',
                secondary: 'purple-600',
                light: 'purple-50'
            }
        },
        { 
            id: 'indigo', 
            name: 'Indigo', 
            colors: {
                primary: 'indigo-800',
                secondary: 'indigo-600',
                light: 'indigo-50'
            }
        },
        { 
            id: 'teal', 
            name: 'Turkis', 
            colors: {
                primary: 'teal-800',
                secondary: 'teal-600',
                light: 'teal-50'
            }
        },
        { 
            id: 'emerald', 
            name: 'Smaragd', 
            colors: {
                primary: 'emerald-800',
                secondary: 'emerald-600',
                light: 'emerald-50'
            }
        },
        { 
            id: 'rose', 
            name: 'Rose', 
            colors: {
                primary: 'rose-800',
                secondary: 'rose-600',
                light: 'rose-50'
            }
        },
        { 
            id: 'cyan', 
            name: 'Cyan', 
            colors: {
                primary: 'cyan-800',
                secondary: 'cyan-600',
                light: 'cyan-50'
            }
        },
        { 
            id: 'sky', 
            name: 'Sky', 
            colors: {
                primary: 'sky-800',
                secondary: 'sky-600',
                light: 'sky-50'
            }
        },
        { 
            id: 'orange', 
            name: 'Orange', 
            colors: {
                primary: 'orange-800',
                secondary: 'orange-600',
                light: 'orange-50'
            }
        },
        { 
            id: 'slate', 
            name: 'Slate', 
            colors: {
                primary: 'slate-800',
                secondary: 'slate-600',
                light: 'slate-50'
            }
        },
        { 
            id: 'zinc', 
            name: 'Zinc', 
            colors: {
                primary: 'zinc-800',
                secondary: 'zinc-600',
                light: 'zinc-50'
            }
        },
        { 
            id: 'neutral', 
            name: 'Neutral', 
            colors: {
                primary: 'neutral-800',
                secondary: 'neutral-600',
                light: 'neutral-50'
            }
        },
        { 
            id: 'lime', 
            name: 'Lime', 
            colors: {
                primary: 'lime-800',
                secondary: 'lime-600',
                light: 'lime-50'
            }
        },
        { 
            id: 'yellow', 
            name: 'Gul', 
            colors: {
                primary: 'yellow-800',
                secondary: 'yellow-600',
                light: 'yellow-50'
            }
        },
        { 
            id: 'stone', 
            name: 'Stone', 
            colors: {
                primary: 'stone-800',
                secondary: 'stone-600',
                light: 'stone-50'
            }
        },
        { 
            id: 'fuchsia', 
            name: 'Fuchsia', 
            colors: {
                primary: 'fuchsia-800',
                secondary: 'fuchsia-600',
                light: 'fuchsia-50'
            }
        },
        { 
            id: 'pink', 
            name: 'Pink', 
            colors: {
                primary: 'pink-800',
                secondary: 'pink-600',
                light: 'pink-50'
            }
        }
    ];

    return (
        <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-lg font-medium font-montserrat text-gray-900 mb-4">Design indstillinger</h2>
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    Farvetema
                </label>
                <div className="grid grid-cols-3 gap-4">
                    {colorThemes.map(theme => (
                        <button
                            key={theme.id}
                            type="button"
                            onClick={() => onChange('theme', theme.id)}
                            className={`p-4 rounded-lg border-2 transition-all duration-200 ${
                                formData.theme === theme.id
                                    ? `border-${theme.colors.primary} bg-${theme.colors.light} shadow-lg ring-2 ring-${theme.colors.primary} ring-offset-2`
                                    : 'border-gray-200 hover:border-gray-300'
                            }`}
                        >
                            <div className={`w-full h-8 rounded bg-${theme.colors.primary} mb-2`} />
                            <div className={`w-full h-4 rounded bg-${theme.colors.secondary}`} />
                            <p className="mt-2 text-sm font-medium text-center">{theme.name}</p>
                            {formData.theme === theme.id && (
                                <p className={`mt-1 text-xs text-${theme.colors.primary} text-center font-medium`}>Valgt</p>
                            )}
                        </button>
                    ))}
                </div>
                
                {/* Preview sektion */}
                {formData.theme && (
                    <div className="mt-8">
                        <h3 className="text-sm font-medium text-gray-700 mb-4">Preview</h3>
                        <div className={`p-4 rounded-lg bg-${formData.theme}-800 text-white`}>
                            <div className="flex gap-4">
                                <button 
                                    type="button" // Tilføj dette
                                    className={`px-4 py-2 rounded bg-${formData.theme}-600 hover:bg-${formData.theme}-700`}
                                >
                                    Primær knap
                                </button>
                                <button 
                                    type="button" // Tilføj dette
                                    className={`text-${formData.theme}-200 hover:text-white`}
                                >
                                    Link eksempel
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}